import {
	SET_ICEPACK_FILLER_INFO,
	SET_IS_ICEPACK_FILLER_INFO_LOADING,
	SET_IS_ICEPACK_FILLER_CREATING,
	SET_IS_ICEPACK_FILLER_UPDATING,
	SET_IS_ICEPACK_FILLER_DELETING,
	RESET_STATE,
} from './actions';

export const initialState = {
	icepackFillerInfo: null,
	isIcepackFillerInfoLoading: false,
	isIcepackFillerCreating: false,
	isIcepackFillerUpdating: false,
	isIcepackFillerDeleting: false,
};

const icepackFillerModalReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_ICEPACK_FILLER_INFO:
			return {
				...state,
				icepackFillerInfo: payload,
			};
		case SET_IS_ICEPACK_FILLER_INFO_LOADING:
			return {
				...state,
				isIcepackFillerInfoLoading: payload,
			};
		case SET_IS_ICEPACK_FILLER_CREATING:
			return {
				...state,
				isIcepackFillerCreating: payload,
			};
		case SET_IS_ICEPACK_FILLER_UPDATING:
			return {
				...state,
				isIcepackFillerUpdating: payload,
			};
		case SET_IS_ICEPACK_FILLER_DELETING:
			return {
				...state,
				isIcepackFillerDeleting: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default icepackFillerModalReducer;
